import {setSessionStore,getSessionStore,removeSessionStore,urlEncode} from 'util/util'

//获取sessionStorage的信息
function fetchArray(key){
	if(getSessionStore(key)){
		return JSON.parse(getSessionStore(key));
	}else{
		return []
	}
}
//设置sessionStorage
function saveArray(key,value){
	setSessionStore(key,JSON.stringify(value));
}
//initial state
const state = {
	tabList:fetchArray('tabList'),
	currentIndex:'',//传给tabs组件,控制子组件display属性
	path:typeof(fetchArray('path')) != 'string'?'/indexhome':fetchArray('path'),
	scrollValue:typeof(fetchArray('scroll')) != 'number' ? 0 : fetchArray('scroll'),
	curSubTab:'detailHome',
	canExport:false,
	homeTipShow:false,
	homeTipTxt:'',
	taskNum:0,
	levv:''
}

const getters = {// 由state派生一些状态，类似组件里的computed
		
	
}

const actions = {//提交mutation,不能直接更改state,可以进行异步操作
	setDefaultMenu({commit},levv){
		commit('setDefaultTab',levv)
	},
	addTab:({commit},obj)=>{	
		commit('saveTabs',obj);	
	},
	goTab:({commit},obj)=>{
		commit('clickTabs',obj)
	},
	closeTab:({commit},index)=>{
		commit('closeTabs',index)
	},
	closeDetailTab({commit},obj){
		commit('closeDetailTabs',obj)
	},
	closeAllTabs:({commit})=>{
		commit('closeAll')
	},
	closeOtherTabs:({commit})=>{
		commit('closeOther')
	},
	getScrollVal:({commit},val)=>{
		commit('scrollVal',val)
	},
	removestorage:({commit})=>{
		commit('clearStorage')
	},
	fileSubTab:({commit},route)=>{
		commit('goSubTab',route)
	},
	exportTrack({commit},bool){
		commit('trackExport',bool)
	},
	openMainTip({commit},txt){
		commit('openHomeTip',txt)
	},
	closeMainTip({commit}){
		commit('closeHomeTip')
	},
	getTaskNum({commit},num){
		commit('saveTaskNum',num)
	}
}

const mutations = {//直接改变state, 必须是同步操作 ---- type(state){//handler回调函数   }
	setDefaultTab(state,levv){
		state.levv = levv;
		if(levv==1){
			state.tabList = [{route:'/indexhome',id:'PageMonitorVehicle',name:'综合监控平台',No:'monitorVehicle'}]
			state.currentIndex = 'monitorVehicle'
		}else{
			state.tabList = [{route:'/indexhome',id:'PageVehicleMonitor',name:'救援服务平台',No:'vehicleMonitor'}]
			state.currentIndex = 'vehicleMonitor'
		}
	},
	saveTabs(state,obj){
		let sourceobj = state.tabList.find(n => n.route === obj.route);
		if (sourceobj === undefined){
			state.tabList.push(obj);
		}
		saveArray('tabList',state.tabList);
		state.currentIndex = obj.No;
	  	saveArray('index',obj.No);
	  	state.path = obj.route;
	  	saveArray('path',state.path)
	},
	clickTabs(state,obj){
		let params ='';
		if (obj.params){
			params= '?' + urlEncode(obj.params);
		}
		saveArray('index',obj.No);
  		state.currentIndex = fetchArray('index');
  		state.path = obj.route+params;
  		saveArray('path',state.path)
	},
	closeTabs(state,index){
		if(index === 0){
			return;
		}
		//active属性 
  		if(state.currentIndex == state.tabList[index].No){//删掉的正是当前tab,active属性往前移一个位置
  			let currentobj = state.tabList[index-1];
  			state.currentIndex = currentobj.No
  			saveArray('index',currentobj.No)
  			state.path = currentobj.route
  			saveArray('path',currentobj.route)
  		}else{//删掉当前选中tab之前或之后的，active属性位置不变
  			state.currentIndex = fetchArray('index');
  		}
  		state.tabList.splice(index,1)//去掉选中的tab
  		var savedTab = fetchArray('tabList')//从tabList缓存中去掉
  		savedTab.splice(index,1)
  		saveArray('tabList',savedTab);
	},
	closeDetailTabs(state,obj){//obj.index==当前tab的No,obj.route==对应一览窗口的route
		if(obj.index === 0){
			return;
		}
		//active属性
		let curNo = state.tabList[obj.index].No  
  		if(state.currentIndex == curNo){//删掉的正是当前tab,active属性移到list位置
  			let tmpI = state.tabList.findIndex(n=>n.route==obj.route)
  			let currentobj = state.tabList[tmpI];
  			if(!currentobj) return;
  			state.currentIndex = currentobj.No
  			saveArray('index',currentobj.No)
  			state.path = currentobj.route
  			saveArray('path',currentobj.route)
  		}else{//删掉当前选中tab之前或之后的，active属性位置不变
  			state.currentIndex = fetchArray('index');
  		}
  		state.tabList.splice(obj.index,1)//去掉选中的tab
  		var savedTab = fetchArray('tabList')//从tabList缓存中去掉
  		savedTab.splice(obj.index,1)
  		saveArray('tabList',savedTab);
	},
	closeAll(state){
  		if(state.tabList.length > 1){
  			state.selected =  state.tabList[0].id;
  			state.path = state.tabList[0].route;
  			state.currentIndex = state.tabList[0].No
  			saveArray('index','vehicleMonitor');
  			saveArray('path',state.tabList[0].route);
  			state.tabList.splice(1,state.tabList.length - 1)
  			saveArray('tabList',state.tabList);
  		}
	},
	closeOther(state){
		var len = state.tabList.length;
		var toSave = [];
		var index = 0;	
		if (state.currentIndex=="vehicleMonitor"){
			toSave = state.tabList.slice(0,1);
			saveArray('tabList',toSave);
		  	state.tabList = toSave;
			return;
		}
		if(len > 1){
		  	for(var i = 1; i < len; i++){
			  	if(state.tabList[i].No == state.currentIndex){
				  	index = i;
				}
			}
		  	toSave = state.tabList.slice(parseInt(index),parseInt(index) + 1);
		  	toSave.unshift(state.tabList[0]);
		  	saveArray('tabList',toSave);
		  	state.tabList = toSave;
		}
		
	},
	scrollVal(state,val){
		state.scrollValue = val;
		saveArray('scroll',state.scrollValue);
	},
	clearStorage(state){
		removeSessionStore('routeArr');
		removeSessionStore('noteArr');
		removeSessionStore('fenceArr');
		removeSessionStore('tabList');
		removeSessionStore('index');
		removeSessionStore('path');
		removeSessionStore('scroll');
		if(state.levv==1){
			state.tabList = [{route:'/indexhome',id:'PageMonitorVehicle',name:'综合监控平台',No:'monitorVehicle'}]
			state.currentIndex = 'monitorVehicle'
		}else{
			state.tabList = [{route:'/indexhome',id:'PageVehicleMonitor',name:'救援服务平台',No:'vehicleMonitor'}]
			state.currentIndex = 'vehicleMonitor'
		}
		
		state.path = '/indexhome'
		state.scrollValue = 0
	},
	goSubTab(state,route){
		state.curSubTab = route
	},
	trackExport(state,bool){
		state.canExport = bool
	},
	openHomeTip(state,txt){
		state.homeTipShow = true
		state.homeTipTxt = txt
	},
	closeHomeTip(state){
		state.homeTipShow = false
		state.homeTipTxt = ''
	},
	saveTaskNum(state,num){
		state.taskNum = num
	}
}
export default{
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js